// @ts-expect-error UnTyped dependency
import { compareLabelFactory } from 'reporting-data/compare';
import { List, Map as ImmutableMap } from 'immutable';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
export const updateComparisonDatasetPropertyLabels = ({
  metrics = [],
  primaryDataset,
  compareDataset,
  report
}) => {
  const metricsList = List(metrics);
  let compareProperties = compareDataset.get('properties');
  const primaryProperties = primaryDataset.get('properties');
  const compareLabel = compareLabelFactory(report);
  if (!isConfigReport(report)) {
    return compareDataset;
  }
  const compare = report.getIn(['config', 'compare']);
  const comparisonLabel = metricLabel => metricsList.count() === 1 ? compareLabel(compare) : compareLabel(compare, metricLabel);
  metricsList.forEach(metric => {
    compareProperties = compareProperties.update(metric, metricProperty => {
      if (metricProperty) {
        return metricProperty.set('label', comparisonLabel(metricProperty.get('label', metric)));
      }
      const primaryMetric = primaryProperties.get(metric);
      return primaryMetric.set('references', ImmutableMap()).set('label', comparisonLabel(primaryMetric.get('label', metric)));
    });
  });
  return compareDataset.set('properties', compareProperties);
};